import React, { Fragment, Component } from 'react';
import styled from 'styled-components';
import { mp, getCampaign } from '../../constants/utils';
import Sticky from 'react-sticky-el';
import VisibilitySensor from 'react-visibility-sensor';
import { FlowHeader, HEADER_HEIGHT } from '../GoalsFlow/styles';
import Title from '../shared/Title';
import { breakpoints, palette, flexRow, flexCenter, flexColumn } from '../../constants/styles';
import Icon from '../shared/Icon';
import FollowingCTA from '../shared/FollowingCTA';

const SUBTITLE_HEIGHT = 30;

const StyledChildrenContent = styled.div`
  ${flexColumn}
  justify-content: center;
  align-items: flex-start;
  padding-top: ${({ showStickySubtitle }) =>
    HEADER_HEIGHT + (showStickySubtitle ? SUBTITLE_HEIGHT : 0) + 10}px;
  margin: 0px 15px;
  margin-bottom: 20px;
  ${breakpoints.mobileLandscape} {
    margin: 0px 100px;
  }
  ${breakpoints.tablet} {
    margin: 0px 120px;
  }

  ${breakpoints.tabletLandscape} {
    margin: 0px 140px;
  }

  ${breakpoints.desktop} {
    margin: 0px 150px;
  }

  ${({ styles }) => styles}
`;

const StyledFollowingSubtitleContainer = styled.a`
  position: fixed;
  z-index: 2000000;
  top: ${HEADER_HEIGHT}px;
  right: 0;
  height: ${SUBTITLE_HEIGHT}px;
  width: 100%;
  ${flexCenter}
  background-color: #808080;
  color: white;
`;

class MasterStickyHeadersResult extends Component {
  state = {
    startedSections: 0,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  onChange(id, idx, child) {
    const { startedSections } = this.state;
    if (idx > startedSections) {
      this.setState({ startedSections: idx }, () => {
        mp(`[${getCampaign(window.location.href)}] | ${id} | ${child.props.title}`);
      });
    }
  }

  render() {
    const {
      resultId,
      children,
      showCTA,
      CTALink,
      CTAPrice,
      CTAText,
      showStickySubtitle,
      stickySubtitleText,
      external,
    } = this.props;

    return (
      <Fragment>
        {children.map((child, idx) => {
          const { headerHeight } = this.state;
          const { id, titleLevel, title, children, styles } = child.props;
          return (
            <div>
              <Sticky bottomOffset={30} key={id} style={{ zIndex: '10000' }}>
                <header>
                  <VisibilitySensor
                    onChange={isVisible => {
                      if (isVisible) {
                        this.onChange(resultId, idx + 1, child);
                      }
                    }}
                  >
                    <FlowHeader>
                      <Title level={titleLevel} color="white">
                        {title}
                      </Title>
                    </FlowHeader>
                  </VisibilitySensor>
                </header>
              </Sticky>
              <StyledChildrenContent styles={styles} showStickySubtitle>
                {children}
              </StyledChildrenContent>
            </div>
          );
        })}
        {showStickySubtitle && (
          <StyledFollowingSubtitleContainer>
            <Title level={5} color="white" align="center">
              {stickySubtitleText}
            </Title>
          </StyledFollowingSubtitleContainer>
        )}
        {showCTA && (
          <FollowingCTA
            customColor={palette.terciaryColor}
            CTAText={CTAText}
            CTALink={CTALink}
            CTAPrice={CTAPrice}
            external={external}
            showArrow
          />
        )}
      </Fragment>
    );
  }
}

MasterStickyHeadersResult.propTypes = {};

MasterStickyHeadersResult.defaultProps = {};

export default MasterStickyHeadersResult;
